<script setup lang="ts">
  import { IconImage } from '@/shared/ui';
  import FileTextIcon from '@/shared/assets/icons/FileTextIcon.svg';
  import UploadSuccessIcon from '@/shared/assets/icons/UploadSuccessIcon.svg';
  import TrashIcon from '@/shared/assets/icons/GrayTrashIcon.svg';

  defineProps<{
    name: string;
  }>();

  const emit = defineEmits<{
    remove: [];
  }>();
</script>

<template>
  <div
    class="flex items-center gap-6 py-3"
    data-testid="upload-record-pdf-file"
  >
    <div class="flex min-w-0 flex-1 items-center gap-5">
      <div class="flex w-72 min-w-0 shrink-0 items-center gap-6">
        <IconImage
          :src="FileTextIcon"
          alt="Arquivo"
          class="size-6 shrink-0 text-gray-07"
        />
        <span
          class="truncate text-sm text-gray-07"
          :title="name"
          data-testid="upload-record-pdf-file-name"
        >
          {{ name }}
        </span>
      </div>
      <div class="flex min-w-0 flex-1 items-center gap-3 px-2.5">
        <div
          class="h-2 min-w-0 flex-1 rounded-full bg-green-19"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="100"
          aria-valuenow="100"
          aria-label="Progresso do upload"
        />
        <span class="text-sm font-medium text-gray-07">100%</span>
      </div>
      <IconImage
        :src="UploadSuccessIcon"
        alt="Upload concluído"
        class="size-5 shrink-0"
        data-testid="upload-record-pdf-file-done"
      />
    </div>
    <button
      type="button"
      class="shrink-0 text-gray-03 hover:text-red-16"
      aria-label="Remover arquivo"
      data-testid="upload-record-pdf-file-remove"
      @click="emit('remove')"
    >
      <IconImage
        :src="TrashIcon"
        alt=""
        class="size-5"
      />
    </button>
  </div>
</template>
